{% block acris_blog_group_detail %}
    <sw-page class="acris-blog-group-detail" v-if="item">

        {% block acris_blog_group_detail_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blog_group_detail_smart_bar_header_title %}
                    <h2>{{ item.internalName ||$tc('acris-blog-group.detail.textHeadline') }}</h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_group_detail_smart_bar_language %}
            <template #language-switch>
                <sw-language-switch @on-change="onChangeLanguage"
                                    :disabled="$route.params.newItem"></sw-language-switch>
            </template>
        {% endblock %}

        {% block acris_blog_group_detail_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_blog_group_detail_smart_bar_actions_cancel %}
                    <mt-button :disabled="item.isLoading" @click="$router.push({ name: 'acris.blog.group.index' })" size="default" variant="secondary">
                        {{ $tc('acris-blog-group.detail.buttonCancel') }}
                    </mt-button>
                {% endblock %}

                {% block acris_blog_group_detail_smart_bar_actions_save %}
                    <sw-button-process
                            :isLoading="isLoading"
                            :processSuccess="processSuccess"
                            variant="primary"
                            :disabled="!item.internalName"
                            @update:processSuccess="saveFinish"
                            @click="onClickSave">
                        {{ $tc('acris-blog-group.detail.buttonSave') }}
                    </sw-button-process>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_group_detail_content %}
            <template #content>
                <sw-card-view>

                    {% block acris_blog_group_detail_settings_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-group-detail-settings"
                                 :title="$tc('acris-blog-group.detail.cardSettingsTitle')">

                            <sw-container columns="1fr 1fr" gap="0 32px">
                                {% block acris_blog_group_detail_internal_name %}
                                    <mt-text-field v-model="item.internalName"
                                                   required
                                                   :label="$tc('acris-blog-group.detail.fieldTitleLabelInternalName')"
                                                   :placeholder="placeholder(item, 'internalName', $tc('acris-blog-group.detail.fieldTitlePlaceholderInternalName'))">
                                    </mt-text-field>
                                {% endblock %}

                                {% block acris_blog_group_detail_active %}
                                    <mt-switch v-model="item.active"
                                                     bordered
                                                   :label="$tc('acris-blog-group.detail.fieldTitleLabelActive')">
                                    </mt-switch>
                                {% endblock %}
                            </sw-container>

                        </mt-card>
                    {% endblock %}

                    {% block acris_blog_group_detail_breadcrumb_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-group-detail-breadcrumb"
                                 :title="$tc('acris-blog-group.detail.cardBreadcrumbTitle')">

                            <sw-container columns="1fr 1fr" gap="0 32px">
                                {% block acris_blog_group_detail_breadcrumbCategoryId %}
                                    <sw-entity-single-select
                                            v-model:value="item.breadcrumbCategoryId"
                                            entity="category"
                                            :label="$tc('acris-blog-group.detail.fieldTitleLabelBreadcrumbCategory')"
                                            :helpText="$tc('acris-blog-group.detail.fieldTitleHelpTextBreadcrumbCategory')"
                                            @update:value="onChangeBreadcrumbCategory">
                                    </sw-entity-single-select>
                                {% endblock %}

                                {% block acris_blog_group_detail_breadcrumbPriority %}
                                    <mt-number-field v-model="item.breadcrumbPriority"
                                                     numberType="int"
                                                     required
                                                     class="acris-blog-group-detail__breadcrumbPriority"
                                                     :label="$tc('acris-blog-group.detail.fieldTitleLabelBreadcrumbPriority')"
                                                     :helpText="$tc('acris-blog-group.detail.fieldTitleHelpTextBreadcrumbPriority')">
                                    </mt-number-field>
                                {% endblock %}
                            </sw-container>

                        </mt-card>
                    {% endblock %}

                </sw-card-view>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
